import axios, { AxiosInstance } from "axios";
import * as rax from "retry-axios";

export const waitForBatchToBeFinished = async (
  transactionId: number,
  timestamp: number
) => {
  const retraxios: AxiosInstance = axios.create();

  rax.attach(retraxios);

  try {
    return await retraxios.get("batches/getTransactionBatch", {
      params: { transactionId, timestamp },
      raxConfig: {
        retry: 15,
        retryDelay: 2500,
        instance: retraxios,
        statusCodesToRetry: [[404, 429]],
        backoffType: "linear",
      },
    });
  } catch (error) {
    if (axios.isAxiosError(error)) {
      switch (error.response?.status) {
        case 404:
          throw new Error("errors.batchNotCreated");
        default:
          throw error;
      }
    }

    throw new Error("UnexpectedError");
  }
};

export default waitForBatchToBeFinished;
